import Navbar from "@/src/free-assessment/_components/Navbar";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div className="h-full min-h-full overflow-y-scroll">
      <Navbar />
      <div className="h-full min-h-full pt-16">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
